import { FinancialData } from "./financial-data"

export interface FinancialModel {
  type: string
  id: string
  attributes: {
    name: string
    strategy: string
    created_at: number
    updated_at: number
  }
  relationships: {
    user_owner: {
      id: number
      type: string
    }
    user_last_updater: {
      id: number
      type: string
    }
    assets: [
      {
        id: string
        type: string
      }
    ]

    financial_datas?: FinancialData[]
  }
}

export const financialModelAttributes = ["name", "strategy", "created_at", "updated_at"]
